export default __webpack_public_path__ + "static/media/arrow-check-white.2816c004.svg";